import { Logtail } from "@logtail/browser";
/**
 * Browser logging backend using official Logtail Browser SDK
 * Ships logs to BetterStack from browser environments
 * Designed for error tracking in production - debug/info logs filtered out
 *
 * @see https://betterstack.com/docs/logs/javascript/
 */
export class BrowserBackend {
    logger;
    enableAllLevels;
    constructor(token, options) {
        const logtailOptions = {};
        if (options?.endpoint) {
            logtailOptions.endpoint = options.endpoint;
        }
        this.logger = new Logtail(token, logtailOptions);
        this.enableAllLevels = options?.enableAllLevels ?? false;
    }
    /**
     * Send log entry to BetterStack
     * In production, only sends errors/warnings unless enableAllLevels is true
     */
    send(entry) {
        const level = entry.level.toLowerCase();
        // In production mode, only send errors and warnings (unless explicitly enabled)
        if (!this.enableAllLevels && level !== "error" && level !== "warn") {
            return;
        }
        const { message, level: _level, ...context } = entry;
        // Use appropriate log level. Fire-and-forget on purpose — send() is sync;
        // the flush() method is the coordinated drain point (e.g. beforeunload).
        switch (level) {
            case "debug":
                void this.logger.debug(message, context);
                break;
            case "info":
                void this.logger.info(message, context);
                break;
            case "warn":
                void this.logger.warn(message, context);
                break;
            case "error":
                void this.logger.error(message, context);
                break;
            default:
                void this.logger.info(message, context);
        }
    }
    /**
     * Flush pending logs
     * Important to call before page unload
     */
    async flush() {
        await this.logger.flush();
    }
}
//# sourceMappingURL=browser.js.map